import classNames from 'classnames';
import { ComponentProps, ReactNode } from 'react';

import Text from '../Text/Text';

import calculateSize from './helpers/calculateSize';

import styles from './Title.module.css';

type TitleProps = {
    variant?: 'section' | 'area' | 'page';
    children?: ReactNode;
    inline?: boolean;
} & ComponentProps<typeof Text>;

const Title = ({
    variant = 'section',
    children,
    inline = false,
    tag = 'h2',
    className,
    bold = true,
    size,
    ...textProps
}: TitleProps) => {
    const classes = classNames(className, {
        [styles.Root]: true,
        [styles.area]: variant === 'area',
        [styles.page]: variant === 'page',
        [styles.inline]: inline,
        [styles.bold]: bold,
    });

    return (
        <Text
            tag={tag}
            className={classes}
            size={calculateSize(variant, size)}
            {...textProps}
        >
            {children}
        </Text>
    );
};

export default Title;
